/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import { CodeBookBbaAddAndSearch } from '../../modules/codeBook/CodeBookBbaAddAndSearch'




const CodeBookBbaPage: FC = () => (
    <>

        <div className='row gy-5 g-xl-8'>
            <CodeBookBbaAddAndSearch className='card-xxl-stretch' />
        </div>
        {/* end::Row */}
    </>
)

const CodeBookWrapperBba: FC = () => {
    const intl = useIntl()
    return (
        <>
            <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.CodeBook' })}</PageTitle>
            <CodeBookBbaPage />
        </>
    )
}

export { CodeBookWrapperBba }
